import React from "react";
import {Route, Switch} from "react-router-dom";
import ViewPolicyDetails from "./ViewPolicyDetails";
import ViewCompleteDetails from "./ViewCompleteDetails";


const App = ({match}) => (
  <Switch>
    <Route exact path={`${match.url}`} component={ViewPolicyDetails} />
    <Route path={`${match.url}/views/:id?`} component={ViewCompleteDetails}/>
  </Switch>
);

export default App;
